import Skeleton from 'react-loading-skeleton';
import React from 'react';
import styled from 'styled-components';
import useMedia from '../../../../hooks/useMedia';


const Wrapper = styled.div`
  background: ${({ theme }) => theme.old ? theme.colors.oatmilk : theme.colors.mist};
  text-align: left;
  margin-bottom: 50px;
  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 64px 64px 64px 15px;

    h1 {
      margin: 0 auto;
      width: 70%;
      text-align: left;
      font-family: ${({ theme }) => theme.fonts.secondary.family};
      letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
      font-style: normal;
      font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
      font-size: 45px;
      line-height: 55px;
      margin-bottom: 0;
    }
    p {
      margin-top: 16px;
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      margin-bottom: 0;
    }
    .take-quiz {
      width: 50%;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
      a {
        transition: all 0.1s;
        color: ${({ theme }) => theme.colors.charcoal};
        &:hover {
          text-decoration: none;
          color: #245caf;
        }
      }
      a span {
        padding-bottom: 3px;
        border-bottom: 2px solid black;
        transition: all 0.1s;
        &:hover {
          border-bottom: 2px solid #245caf;
        }
      }
    }
    &.one-column {
      max-width: 750px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 15px;
      padding-right: 15px;
      h1,
      p {
        text-align: center;
      }
    }
  }
  .image-wrapper {
    display: flex;
    align-items: center;
  }

  @media (max-width: 992px) {
    margin-bottom: 0;
    .container {
      max-width: 100%;
      .row-wrapper {
        .text-wrapper {
          padding: 30px 15px;
          h1 {
            font-size: 30px;
            line-height: 40px;
          }
          p {
            font-size: 16px;
            line-height: 23px;
          }
          h1,
          p {
            text-align: center;
          }
        }
        .image-wrapper {
        }
      }
    }
  }
`;

const InstagramHandle = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 13px;
  cursor: pointer;
  padding: 5px;
  background: rgba(255, 255, 255, 0.7);
  a {
    color: ${({ theme }) => theme.colors.charcoal};
    text-decoration: none;
  }
  @media (max-width: 992px) {
    width: 100%;
    text-align: center;
  }
`;

const DarkButtonLink = styled.a`
  margin-top: 30px;
  width: 200px;
  border: 1px solid black;
  background: black;
  padding: 15px 5px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-decoration: none;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.04em;
  display: flex;
  justify-content: center;
  color: white;

  transition: all 0.3s;
  &:hover {
    color: white;
    text-decoration: none;
    background: #4d4d4d;
  }
`;

function SectionHeaderSkeleton({ description, image, showQuizLink }) {
  const isMobile =
    typeof window !== `undefined` ? useMedia('(max-width: 992px) ') : null;

  const textModule = () => {
    return (
      <div
        className={`${isMobile ? 'col-12' : 'col'} text-wrapper ${
          image ? 'two-column' : 'one-column'
        }`}
      >
        <h1>
          <Skeleton />
        </h1>

        <div className="text-center">
          <Skeleton />
        </div>

        {description && (
          <p>
            <Skeleton />
          </p>
        )}

        {showQuizLink && (
          <div className="take-quiz">
            <Skeleton />
          </div>
        )}
      </div>
    );
  };

  const imageModule = () => {
    return (
      <div className={`${isMobile ? 'col-12' : 'col'} p-0 image-wrapper`}>
        <div className="position-relative w-100">
          <Skeleton />
        </div>
      </div>
    );
  };

  return (
    <Wrapper>
      <div className="container mb-0">
        <div className="row row-wrapper">
          {isMobile ? (
            <>
              {image && imageModule()}
              {textModule()}
            </>
          ) : (
            <>
              {textModule()}
              {image && imageModule()}
            </>
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export default SectionHeaderSkeleton;
